import { Customer } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;
let cachedCustomers: Customer[];

export const CustomerService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getCustomers = async (customerId?: string, useCache: boolean = true): Promise<Customer[]> => {
    if (useCache && customerId == null && cachedCustomers != null)
      return cachedCustomers;

    return await fetch('/api/Customer/get?' + new URLSearchParams({
      customerId: customerId?.toString() ?? '',
    }),
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF': '1',
        }
      }
    ).then(customers => customers.json());
  };

  return {
    setDotNetReference,
    getCustomers,
  };
})();
